// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
  householdId: Types.Scalars['ID']['input'];
  entityId: Types.Scalars['ID']['input'];
  currentTimestamp: Types.Scalars['Time']['input'];
}>;


export type GetIlitAnnualExclusionGiftsTaskDetailsQuery = { __typename?: 'Query', entityTasks: { __typename?: 'EntityTaskConnection', edges?: Array<{ __typename?: 'EntityTaskEdge', node?: { __typename?: 'EntityTask', id: string, completionState: Types.EntityTaskCompletionState } | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, displayName: string, assignedEmployees?: Array<{ __typename?: 'Employee', id: string, displayName: string }> | null, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'CLTTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'CRTTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'GRATTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'ILITTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'PrivateFoundation', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'QPRTTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'RevocableTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'SLATTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } } | null } | null> | null } } | null } | null> | null }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, tasks: { __typename?: 'EntityTaskConnection', edges?: Array<{ __typename?: 'EntityTaskEdge', node?: { __typename?: 'EntityTask', type: Types.EntityTaskType, id: string, shortTitle: string, premiumPayment?: { __typename?: 'InsurancePremiumPayment', id: string, dueOn?: Time | null } | null } | null } | null> | null }, subtype: { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTTrust', id: string } | { __typename?: 'CRTTrust', id: string } | { __typename?: 'CustodialPersonalAccount', id: string } | { __typename?: 'DonorAdvisedFund', id: string } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATTrust', id: string } | { __typename?: 'ILITTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null }> | null, policies?: Array<{ __typename?: 'InsurancePolicy', id: string, premiumAmount?: CurrencyUSD | null, premiumFrequency?: Types.InsurancePolicyPremiumFrequency | null }> | null, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string }, individual?: { __typename?: 'ClientProfile', id: string, displayName: string, relationships?: Array<{ __typename?: 'ClientProfileRelationship', id: string, relationID: string, type: Types.ClientProfileRelationshipType }> | null } | null }> | null } | { __typename?: 'IndividualPersonalAccount', id: string } | { __typename?: 'InsurancePersonalAccount', id: string } | { __typename?: 'IrrevocableTrust', id: string } | { __typename?: 'JointPersonalAccount', id: string } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'PrivateFoundation', id: string } | { __typename?: 'QPRTTrust', id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string } | { __typename?: 'RetirementPersonalAccount', id: string } | { __typename?: 'RevocableTrust', id: string } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    GetILITAnnualExclusionGiftsTaskDetails: 'GetILITAnnualExclusionGiftsTaskDetails' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetIlitAnnualExclusionGiftsTaskDetailsDocument = gql`
    query GetILITAnnualExclusionGiftsTaskDetails($taskId: ID!, $householdId: ID!, $entityId: ID!, $currentTimestamp: Time!) {
  entityTasks(where: {id: $taskId}) {
    edges {
      node {
        id
        completionState
      }
    }
  }
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        displayName
        assignedEmployees {
          id
          displayName
        }
        entities(
          where: {kindNotIn: [CUSTODIAL_PERSONAL_ACCOUNT, QUALIFIED_TUITION_PERSONAL_ACCOUNT, GRAT_TRUST, ILIT_TRUST, QPRT_TRUST, CRT_TRUST, CLT_TRUST, PRIVATE_FOUNDATION, DONOR_ADVISED_FUND, INSURANCE_PERSONAL_ACCOUNT]}
        ) {
          edges {
            node {
              id
              kind
              subtype {
                id
                displayName
                designerAccount {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
  entities(where: {id: $entityId}) {
    edges {
      node {
        id
        tasks(
          where: {and: [{type: ILIT_MAKE_PREMIUM_PAYMENT}, {hasPremiumPaymentWith: {dueOnGTE: $currentTimestamp}}]}
        ) {
          edges {
            node {
              premiumPayment {
                id
                dueOn
              }
              type
              id
              shortTitle
            }
          }
        }
        subtype {
          id
          ... on ILITTrust {
            id
            displayName
            designerAccount {
              id
            }
            grantors {
              id
              individual {
                id
                displayName
              }
            }
            policies {
              id
              premiumAmount
              premiumFrequency
            }
            beneficiaries {
              id
              summary {
                id
                displayName
              }
              individual {
                id
                displayName
                relationships {
                  id
                  relationID
                  type
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetIlitAnnualExclusionGiftsTaskDetailsQuery__
 *
 * To run a query within a React component, call `useGetIlitAnnualExclusionGiftsTaskDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIlitAnnualExclusionGiftsTaskDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIlitAnnualExclusionGiftsTaskDetailsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      householdId: // value for 'householdId'
 *      entityId: // value for 'entityId'
 *      currentTimestamp: // value for 'currentTimestamp'
 *   },
 * });
 */
export function useGetIlitAnnualExclusionGiftsTaskDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>(GetIlitAnnualExclusionGiftsTaskDetailsDocument, withFetchPolicyContext(options));
      }
export function useGetIlitAnnualExclusionGiftsTaskDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>(GetIlitAnnualExclusionGiftsTaskDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetIlitAnnualExclusionGiftsTaskDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>(GetIlitAnnualExclusionGiftsTaskDetailsDocument, withFetchPolicyContext(options));
        }
export type GetIlitAnnualExclusionGiftsTaskDetailsQueryHookResult = ReturnType<typeof useGetIlitAnnualExclusionGiftsTaskDetailsQuery>;
export type GetIlitAnnualExclusionGiftsTaskDetailsLazyQueryHookResult = ReturnType<typeof useGetIlitAnnualExclusionGiftsTaskDetailsLazyQuery>;
export type GetIlitAnnualExclusionGiftsTaskDetailsSuspenseQueryHookResult = ReturnType<typeof useGetIlitAnnualExclusionGiftsTaskDetailsSuspenseQuery>;
export type GetIlitAnnualExclusionGiftsTaskDetailsQueryResult = Apollo.QueryResult<GetIlitAnnualExclusionGiftsTaskDetailsQuery, GetIlitAnnualExclusionGiftsTaskDetailsQueryVariables>;